import { render } from "./magicLink.vue?vue&type=template&id=a5d9e604&scoped=true"
import script from "./magicLink.vue?vue&type=script&lang=js"
export * from "./magicLink.vue?vue&type=script&lang=js"

import "./magicLink.vue?vue&type=style&index=0&id=a5d9e604&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d9e604"]])

export default __exports__